module.exports = __webpack_public_path__ + "static/media/map-location.b823616b.svg";